module.exports = __webpack_public_path__ + "media/images/registration/air_force_cac-6edcacbf08b4ce31e6b2c09b1658b952.svg";